export default __webpack_public_path__ + "static/iso-images-e4a34ce700a0d36f3c1ede95fce9777d.svg";